import { useState, useEffect } from 'react'

const BackgroundContainer = ({ images = {}, src }) => {
    const [sources, setSources] = useState({ ...images, [src]: true })
    const [current, setCurrent] = useState(src)

    useEffect(() => {
        if (src && !sources[src]) {
            setSources(prevSources => ({
                ...prevSources,
                [src]: true,
            }))
        }
        if (src && current !== src) {
            setCurrent(src)
        }
    }, [src, current, sources])

    const renderedImages = Object.keys(sources).map((v, i) => {
        const classNames = current === v ? 'current' : ''
        return <img key={i} src={v} className={classNames} alt="" />
    })

    return <div className="background-container">{renderedImages}</div>
}

export default BackgroundContainer
